import {
  getFavoritePosts,
  getPinnedPosts,
  getPostByContentId,
  getPostById,
  getPosts,
  getPostsByUserId,
} from "@/lib/humhub-api/posts/read";
import {
  createOrDeleteReaction,
  createPost,
  deletePost,
  editPost,
  movePostChannel,
  removePostFile,
  replacePostFile,
  reportPost,
  toggleFavorite,
  updatePost,
  uploadFilesToPost,
} from "@/lib/humhub-api/posts/write";

export const postsApi = {
  getPosts,
  createPost,
  createOrDeleteReaction,
  updatePost,
  editPost,
  movePostChannel,
  deletePost,
  reportPost,
  toggleFavorite,
  getFavoritePosts,
  getPostByContentId,
  getPostById,
  getPostsByUserId,
  getPinnedPosts,
  removePostFile,
  replacePostFile,
  uploadFilesToPost,
};
